import { STORAGE_KEYS } from '../../constants';
import { VendingMachine, Order } from '../../types';

export const LOCAL_STORAGE_KEYS = {
    LANGUAGE: 'lang',
    VM_STATE: STORAGE_KEYS.VM_STATE,
    VM_SYNC_TIMESTAMP: STORAGE_KEYS.VM_SYNC_TIMESTAMP,
    ORDER_STATE: STORAGE_KEYS.ORDER_STATE,
    ORDER_SYNC_TIMESTAMP: STORAGE_KEYS.ORDER_SYNC_TIMESTAMP,
    TAB_ID: STORAGE_KEYS.TAB_ID,
    TAB_START_TIMESTAMP: STORAGE_KEYS.TAB_START_TIMESTAMP,
    APP_VERS: STORAGE_KEYS.APP_VERS,
    STORE_TIMESTAMP: STORAGE_KEYS.STORE_TIMESTAMP,
    DEBUG_IS_ALLOWED: STORAGE_KEYS.DEBUG_IS_ALLOWED,
    TIMER_END_TIMESTAMP: STORAGE_KEYS.TIMER_END_TIMESTAMP,
    LOYALTY_BANNER_SEEN: STORAGE_KEYS.LOYALTY_BANNER_SEEN,
} as const;

/** Semantic key names for type-safe access */
export type LocalStorageKeyName = keyof typeof LOCAL_STORAGE_KEYS;

export interface LocalStorageValueMap {
    LANGUAGE: string;
    VM_STATE: VendingMachine | Record<string, unknown>;
    VM_SYNC_TIMESTAMP: string;
    ORDER_STATE: Order | Record<string, unknown>;
    ORDER_SYNC_TIMESTAMP: string;
    TAB_ID: string;
    TAB_START_TIMESTAMP: string;
    APP_VERS: string;
    STORE_TIMESTAMP: string;
    DEBUG_IS_ALLOWED: string;
    TIMER_END_TIMESTAMP: string;
    LOYALTY_BANNER_SEEN: string;
}

export const LOCAL_STORAGE_DEFAULTS: { [K in LocalStorageKeyName]: LocalStorageValueMap[K] } = {
    LANGUAGE: '',
    VM_STATE: {},
    VM_SYNC_TIMESTAMP: '0',
    ORDER_STATE: {},
    ORDER_SYNC_TIMESTAMP: '0',
    TAB_ID: '',
    TAB_START_TIMESTAMP: '0',
    APP_VERS: '',
    STORE_TIMESTAMP: '0',
    DEBUG_IS_ALLOWED: '',
    TIMER_END_TIMESTAMP: '0',
    LOYALTY_BANNER_SEEN: '',
};
